import request from "@/utils/request";

// 游戏列表
export function getGameList(query) {
  return request({
    url: '/recommendBox/getPayMallInfo',
    // url: '/recommendBox/getInfo',
    headers: {
      isToken: false,
	  isGmApi: true
    },
    method: 'get',
	params: query
  })
}
// 游戏列表
export function getGameSearch(query) {
  return request({
    url: '/banner/search',
    headers: {
      isToken: false,
	  isGmApi: true
    },
    method: 'get',
	params: query
  })
}

// 商品列表
export function getGoodList(query) {
  return request({
    url: '/userSonInfo/getGoods',
    headers: {
      isToken: true
    },
    method: 'post',
	data: query
  })
}
// 购物车列表
export function getCartList(userid) {
  return request({
    url: '/function/shoppingCart/getList/' + userid,
    headers: {
      isToken: true
    },
    method: 'get'
  })
}
// 加入购物车
export function addCartGood(query) {
  return request({
    url: '/function/shoppingCart/addInfo',
    headers: {
      isToken: true
    },
    method: 'post',
	data: query
  })
}
// 更新购物车
export function updateCartGood(query) {
  return request({
    url: '/function/shoppingCart/updateInfo',
    headers: {
      isToken: true
    },
    method: 'put',
	data: query
  })
}
// 删除购物车
export function delCartGood(ids) {
  return request({
    url: '/function/shoppingCart/deleteByIds/'+ids,
    headers: {
      isToken: true
    },
    method: 'get'
  })
}

